<div class="footer-text">
  <span class="footer-version">Version {{ appVersion }}</span>
  <nav class="footer-links" aria-label="Legal">
    <ul>
      @for (link of footerLinks; track link.url) {
        <li>
          <a [href]="link.url" target="_blank" rel="noopener"
            >{{ link.label }}<span class="cdk-visually-hidden">
              (opens in a new tab)</span
            ></a
          >
        </li>
      }
    </ul>
  </nav>
  <span class="footer-powered">
    <strong>Powered by File &amp; ServeXpress</strong> &#169;
    {{ currentDate | date: 'yyyy' }} All rights reserved.
  </span>
</div>
